module.exports = __webpack_public_path__ + "static/media/상속증여.3fd2cef8.png";